import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';
@Component({
  selector: 'app-adfs-webservices',
  templateUrl: './adfs-webservices.component.html',
  styleUrls: ['./adfs-webservices.component.scss']
})
export class AdfsWebservicesComponent implements OnInit {
  adfswebList: any = [];
  updateListAdfsWebAuth: any = [];
  updateListAdfsWebDeauth: any = [];
  adfsauthorizeidlist: any = [];
  adfsdeauthorizeidlist: any = [];
  idlistofdeauth: any = [];
  idlistofauth: any = [];
  weblistnamesList: any = [];
  adfswebnameAdd: any;
  erroradfswebWebname: boolean = false;
  erroradfswebnameLength: boolean = false;
  erroradfswebdetailsLength: boolean = false;
  erroradfswebdetailsUpLength: boolean = false;
  tickeddeauth: boolean = false;
  tickedauth: boolean = false;
  adfswebdetailsAdd: any;
  erroradfswebdetails: boolean = false;
  adfswebwslcheckboxAdd: boolean = false;
  noerrorinaddadfsweb: boolean = false;
  adfswebnameUp: any;
  adfswebdetailsUp: any;
  erroradfswebdetailsup: boolean = false;
  adfswebwslcheckboxUp: any;
  adfswebdeauthorize: any;
  deauthTable: boolean = false;
  adfswebdeauthorizevar: boolean = false;
  adfswebauthorizevar: boolean = false;
  adfswebisChecked: boolean = false;
  idtobeeditted: any;
  deletewebid: any;
  nameexisterror: boolean = false;
  isBackToTopShowBtn: boolean = false;

  constructor(private modalService: NgbModal, private service: ApifirstService, private router: Router) { }

  ngOnInit(): void {
    this.service.getAdfsWeb().subscribe((data) => {
      this.adfswebList = data
      this.weblistnamesList = []
      for (let name of this.adfswebList) {
        this.weblistnamesList.push(name.name);
      }
    })
  }
  /* WSL Fallback checkbox click while adding*/
  adfswebwsladdChecked(adfswebwslcheckboxAdd: any) {
    if (adfswebwslcheckboxAdd == false) {
      this.adfswebwslcheckboxAdd = false;
    }
    else {
      this.adfswebwslcheckboxAdd = true;
    }
  }
  /* WSL Fallback checkbox click while updating*/
  adfswebwsladdCheckedUp(adfswebwslcheckboxUp: any) {
    if (adfswebwslcheckboxUp == false) {
      this.adfswebwslcheckboxUp = false;
    }
    else {
      this.adfswebwslcheckboxUp = true;
    }
  }
  /* on click of Add button */
  addAdfsweb(addadfswebfile: any) {
    this.clearVariablesadfsweb();
    this.modalService.open(addadfswebfile, { centered: true });
    this.deauthTable = false;
    this.adfswebnameAdd = '';
    this.adfswebdetailsAdd = '';
    this.adfswebwslcheckboxAdd = false;
    this.service.getAdfsWeb().subscribe((data) => {
      this.adfswebList = data
      this.weblistnamesList = []
      for (let name of this.adfswebList) {
        this.weblistnamesList.push(name.name);
      }
    })
  }
  /* On click of submit button in add popup */
  setsubmiteditadfswebAdd(adfswebnameAdd: any, adfswebdetailsAdd: any) {
    this.clearVariablesadfsweb();
    if (adfswebnameAdd == null || adfswebnameAdd == undefined || adfswebnameAdd == '' ||
      adfswebnameAdd.length === 0) {
      this.erroradfswebWebname = true;
    }
    else {
      this.erroradfswebWebname = false;
    }
    if (adfswebnameAdd.length > 50) {
      this.erroradfswebnameLength = true;
    }
    else {
      this.erroradfswebnameLength = false;
    }
    if (adfswebdetailsAdd == null || adfswebdetailsAdd == undefined || adfswebdetailsAdd == '' ||
      adfswebdetailsAdd.length === 0) {
      this.erroradfswebdetails = true;
    }
    else {
      this.erroradfswebdetails = false;
    }
    if (adfswebdetailsAdd.length > 70) {
      this.erroradfswebdetailsLength = true;
    }
    else {
      this.erroradfswebdetailsLength = false;
    }
    if (this.weblistnamesList.includes(adfswebnameAdd)) {
      this.nameexisterror = true;
    }
    else {
      this.nameexisterror = false;
    }
    if (this.erroradfswebWebname == false && this.erroradfswebdetails == false
      && this.nameexisterror == false && this.erroradfswebdetailsLength == false
      && this.erroradfswebnameLength == false) {
      this.noerrorinaddadfsweb = true;
    }
    else {
      this.noerrorinaddadfsweb = false;
    }
    let req = {
      "name": adfswebnameAdd,
      "details": adfswebdetailsAdd,
      "wslAuthFallback": this.adfswebwslcheckboxAdd
    }
    if (this.noerrorinaddadfsweb == true) {
      this.service.addAdfsWeb(req).subscribe((datas) => {
        this.service.getAdfsWeb().subscribe((data) => {
          this.adfswebList = data
          this.weblistnamesList = []
          for (let name of this.adfswebList) {
            this.weblistnamesList.push(name.name);
          }
        })
        this.modalService.dismissAll(true);
      });
    }
  }
  /* On click of edit button */
  editAdfswebdata(id: any, editadfswebCredentials: any) {
    this.clearVariablesadfsweb();
    this.updateListAdfsWebDeauth = []
    this.adfsdeauthorizeidlist = []
    this.adfsauthorizeidlist = []
    this.deauthTable = false;
    this.idtobeeditted = id;
    this.modalService.open(editadfswebCredentials, { centered: true });
    this.service.getAdfsWebDeauth(id).subscribe((data) => {
      this.updateListAdfsWebDeauth = data.adfsClients
      this.adfswebnameUp = data.name
      this.adfswebdetailsUp = data.details
      this.adfswebwslcheckboxUp = data.wslAuthFallback
    });
  }
  /* On click of delete button */
  deleteAdfswebdata(id: any, deletePopUpadfsweb: any) {
    this.modalService.open(deletePopUpadfsweb, { centered: true });
    this.deletewebid = id;
  }
  /*on click of delete button in delete popup*/
  deletePopcredentialadfsweb() {
    this.service.deleteAdfsWeb(this.deletewebid).subscribe((data) => {
      this.service.getAdfsWeb().subscribe((data) => {
        this.adfswebList = data
        this.weblistnamesList = []
        for (let name of this.adfswebList) {
          this.weblistnamesList.push(name.name);
        }
      })
    });
  }
  /* On click of authorize new client button in edit popup*/
  authorizeNewClient() {
    this.deauthTable = true;
    this.updateListAdfsWebAuth = []
    this.service.getAdfsWebAuth(this.idtobeeditted).subscribe((data) => {
      this.updateListAdfsWebAuth = data.adfsClient
    });
  }
  /* On click of deauthorize checkbox in edit popup*/
  adfswebdeauthorizecheck(obj: any) {
    this.tickeddeauth = false
    this.idlistofauth = []
    for (let i of this.updateListAdfsWebDeauth) {
      this.idlistofauth.push(i.id)
    }
    for (let i in this.idlistofauth) {
      if (this.idlistofauth[i] == obj.id) {
        this.tickeddeauth = true
        this.adfsdeauthorizeidlist.push(obj.id)
      }
    }
  }
  /* On click of submit button in edit popup where deauthorize checkbox are there*/
  setsubmiteditadfswebupdatefirst() {
    if (this.adfswebdetailsUp == null || this.adfswebdetailsUp == undefined || this.adfswebdetailsUp == '' ||
      this.adfswebdetailsUp.length === 0) {
      this.erroradfswebdetailsup = true;
    }
    else {
      this.erroradfswebdetailsup = false;
    }
    if (this.adfswebdetailsUp.length > 70) {
      this.erroradfswebdetailsUpLength = true;
    }
    else {
      this.erroradfswebdetailsUpLength = false;
    }
    let det = {
      "name": this.adfswebnameUp,
      "details": this.adfswebdetailsUp,
      "wslAuthFallback": this.adfswebwslcheckboxUp
    }
    if (!this.erroradfswebdetailsup && !this.erroradfswebdetailsUpLength) {
      this.service.editWebserviceAdfs(this.idtobeeditted, det).subscribe((data) => {
        this.service.getAdfsWeb().subscribe((data) => {
          this.adfswebList = data
          this.weblistnamesList = []
          for (let name of this.adfswebList) {
            this.weblistnamesList.push(name.name);
          }
        })
      })
      let req = {
        "webserviceId": this.idtobeeditted,
        "clientId": this.adfsdeauthorizeidlist
      }
      this.service.editDeauthorize(this.tickeddeauth, req).subscribe((data) => {
        this.modalService.dismissAll(true);
      })
    }
  }
  /* On click of authorize checkbox in edit popup*/
  adfswebauthorizecheck(obj: any) {
    this.tickedauth = false
    this.idlistofdeauth = []
    for (let i of this.updateListAdfsWebAuth) {
      this.idlistofdeauth.push(i.id)
    }
    for (let i in this.idlistofdeauth) {
      if (this.idlistofdeauth[i] == obj.id) {
        this.tickedauth = true
        this.adfsauthorizeidlist.push(obj.id)
      }
    }
  }
  /* On click of submit button in edit popup where authorize checkbox are there*/
  setsubmiteditadfswebupdatesecond() {
    let req = {
      "webserviceId": this.idtobeeditted,
      "clientId": this.adfsauthorizeidlist
    }
    this.service.editAuthorize(this.tickedauth, req).subscribe((data) => {
      this.modalService.dismissAll(true);
    })
    this.service.getAdfsWeb().subscribe((data) => {
      this.adfswebList = data
      this.weblistnamesList = []
      for (let name of this.adfswebList) {
        this.weblistnamesList.push(name.name);
      }
    })
  }
  clearVariablesadfsweb() {
    this.erroradfswebWebname = false;
    this.erroradfswebdetails = false;
    this.erroradfswebdetailsup = false;
    this.noerrorinaddadfsweb = false;
    this.nameexisterror = false;
    this.erroradfswebdetailsLength = false;
    this.erroradfswebnameLength = false;
    this.erroradfswebdetailsUpLength = false;
  }

  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event: any) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
}

